var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSideLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.169,
    height: 61.122,
    viewBox: "0 0 58.169 61.122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_44",
    "data-name": "\\u30D1\\u30B9 44",
    d: "M57.874-47.638h0V-61.417H43.332v28.445a13.957,13.957,0,0,1-3.568.615,16.441,16.441,0,0,1-3.863-.615V-61.417H21.358v33.858L14.247-40.453V-61.417H-.3V-.3H14.247V-34.154L21.358-21.58V-.3H35.9v-29.38a17.169,17.169,0,0,0,3.863.3,14.587,14.587,0,0,0,3.568-.3V-.3H57.874V-47.638Zm-46.6,2.092L3.863-58.44H11.27Zm0,42.249H2.682V-54.232L11.27-39.567ZM32.948-58.44v24.286a14.719,14.719,0,0,1-8.317-13.484h0v-10.8ZM24.631-16.191,31.767-3.3H24.631ZM32.948-7.5,24.631-22.17V-37.451a20.749,20.749,0,0,0,8.317,6.89ZM46.284-58.44H54.9v10.8a14.938,14.938,0,0,1-8.613,13.484ZM54.9-3.3H46.284V-30.561a19.78,19.78,0,0,0,8.613-6.89Z",
    transform: "translate(0.295 61.417)",
    fill: "#474747"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideLogo);
export default __webpack_public_path__ + "static/media/side-logo.97d15ce5899d2a8e65562c1e17f18be4.svg";
export { ForwardRef as ReactComponent };